import React, { useEffect, useContext } from "react";
import CreditsUI from "./creditsui";
import CheckoutUI from "./checkoutui";
import NextLink from "next/link";
import { CheckoutContext } from "../lib/CheckoutContext";
import { logAmplitudeEvent } from '../lib/amplitude';
import { PUBLIC_ROUTES } from '../lib/routes';

export default function BuyCredits(props) {
  let modal_open = props.modal_open || false;
  const { checkoutOpen, setCheckoutOpen, uiLocation, setUiLocation, paymentClientSecret, paymentMode } = useContext(CheckoutContext);
  let modal_id = props.modal_id || false;  
  useEffect(() => {
    if (uiLocation == props.trigger_source || modal_id) {
      logAmplitudeEvent('Credits View', { trigger: trigger, pageRoute: window.location.pathname  })
    }
  }
  , []);  
  // let direct_to_checkout = paymentClientSecret ? true : (props.direct_to_checkout || false);
  let direct_to_credits = paymentClientSecret ? false : (props.direct_to_credits || paymentMode == "payment");
  let trigger = props.trigger || "buy-credits";

  function closeAll(modal_open=false) {
    props.setBuyCreditsModalOpen(false);
    setCheckoutOpen(false);
    if (modal_id && !modal_open) {
        const modalCheckbox = document.getElementById(modal_id);
        modalCheckbox.checked = false;
    }
  }

  function closeCredits() {
    props.setBuyCreditsModalOpen(false);
    setCheckoutOpen(false);    
  }

  if (uiLocation == props.trigger_source) {
    return (
    <>
      <input type="checkbox" id="my-modal-checkout" className="modal-toggle" />
      <div id="my-modal-checkout-modal" className={`modal ${modal_open ? 'modal-open' : null} z-[999]`}>
            <div className={` ${checkoutOpen ? "bg-[#fff7ed]" : "bg-base-100"} w-[90%] modal-box card lg:card-side  p-0 max-w-[95%] md:w-[680px] lg:w-[840px] md:max-w-[50%]`}>
            {modal_id ? 
              <label htmlFor="my-modal-checkout" onClick={closeCredits} className="btn btn-sm bg-transparent btn-outline border-none z-[11] absolute left-2 top-2 mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 mr-2 text-slate-600">
                      <path fillRule="evenodd" d="M10.707 3.293a1 1 0 010 1.414L6.414 9H13a7 7 0 110 14H7a1 1 0 010-2h6a5 5 0 100-10H6.414l4.293 4.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z" clipRule="evenodd"/>
                  </svg>
                  Back
              </label> : null
            }
            {!modal_id ? 
              <label htmlFor="my-modal-checkout" onClick={() => setCheckoutOpen(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>    
              : modal_open ?  <NextLink href={PUBLIC_ROUTES.faceContour} onClick={() => closeAll(true)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</NextLink> :
              <label htmlFor="my-modal-checkout" onClick={closeAll} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>
            }    
            {direct_to_credits && !checkoutOpen ? 
              <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen}/> :
              <div className="card-body">
              <CheckoutUI id_append={trigger} margin_top={modal_id} /> 
              <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>        
              </div>
            }              
          </div>
      </div>  
    </>      
    )
  }

  // else if ((uiLocation == props.trigger_source) && direct_to_credits) {
  //   return (
  //     <>
  //     <input type="checkbox" id="my-modal-checkout" className="modal-toggle" />
  //     <div id="my-modal-checkout-modal" className={`modal ${modal_open ? 'modal-open' : null} z-[999]`}>
  //         <div className={` ${checkoutOpen ? "bg-[#fff7ed] w-[350px]" : "bg-base-100 w-[300px]"} modal-box card lg:card-side  p-0 max-w-[95%] md:w-[680px] lg:w-[840px] md:max-w-[50%]`}>
  //             <label htmlFor="my-modal-checkout" onClick={() => setCheckoutOpen(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>
  //             {checkoutOpen ? 
  //             <div className="card-body">
  //             <CheckoutUI id_append={trigger} margin_top={true} /> 
  //             <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>        
  //             </div>              
  //             : 
  //             <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen}/>}              
  //         </div>
  //     </div>  
  //     </>        
  //   )
  // }
  else {
    return;
  }
  //   
  //   setCheckoutOpen(true);
  //   return (
  //     <div className={`modal modal-open z-[999]`}>
  //     <div className={`overflow-visible modal-box card lg:card-side ${checkoutOpen ? "bg-[#fff7ed] w-[350px]" : "bg-base-100 w-[300px]"} p-0 max-w-[95%] md:w-[575px] lg:w-[680px] md:max-w-[50%]`}>
  //       {modal_id ? 
  //       <label htmlFor="buy-credits-modal" onClick={closeCredits} className="btn btn-sm bg-transparent btn-outline border-none z-[11] absolute left-2 top-2 mb-2">
  //           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 mr-2 text-slate-600">
  //               <path fillRule="evenodd" d="M10.707 3.293a1 1 0 010 1.414L6.414 9H13a7 7 0 110 14H7a1 1 0 010-2h6a5 5 0 100-10H6.414l4.293 4.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z" clipRule="evenodd"/>
  //           </svg>
  //           Back
  //       </label> : null}
  //       {modal_open ? 
  //       <NextLink href={PUBLIC_ROUTES.faceContour} onClick={() => setCheckoutOpen(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</NextLink>
  //        : 
  //       <label onClick={closeAll} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>}
  //       {checkoutOpen ? 
  //       <div className="overflow-scroll rounded-2xl items-center w-full text-center">
  //         <CheckoutUI id_append={trigger}/>
  //         <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>
  //       </div>
  //       : 
  //       <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen} ui_location={"credits-paywall"}/>}
  //     </div>
  //   </div>      
  //   )
  // }
  // return (
  //   <>
  //   <input type="checkbox" id="my-modal-checkout" className="modal-toggle" />
  //   <div id="my-modal-checkout-modal" className={`modal ${modal_open ? 'modal-open' : null} z-[999]`}>
  //       <div className={` ${checkoutOpen ? "bg-[#fff7ed] w-[350px]" : "bg-base-100 w-[300px]"} modal-box card lg:card-side  p-0 max-w-[95%] md:w-[680px] lg:w-[840px] md:max-w-[50%]`}>
  //       {modal_id ? 
  //   <label htmlFor="my-modal-checkout" onClick={closeCredits} className="btn btn-sm bg-transparent btn-outline border-none z-[11] absolute left-2 top-2 mb-2">
  //       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 mr-2 text-slate-600">
  //           <path fillRule="evenodd" d="M10.707 3.293a1 1 0 010 1.414L6.414 9H13a7 7 0 110 14H7a1 1 0 010-2h6a5 5 0 100-10H6.414l4.293 4.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z" clipRule="evenodd"/>
  //       </svg>
  //       Back
  //   </label> : null}
  //   {modal_open ? 
  //   <NextLink href={PUBLIC_ROUTES.faceContour} onClick={() => setCheckoutOpen(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</NextLink>
  //    : 
  //   <label htmlFor="my-modal-checkout" onClick={closeAll} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>}
  
  //           {checkoutOpen ? 
  //           <div className="card-body">
  //           <CheckoutUI id_append={trigger} margin_top={true} /> 
  //           <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>        
  //           </div>              
  //           : 
  //           <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen}/>}              
  //       </div>
  //   </div>  
  //   </>  
  // );
};


  // {checkoutOpen ? 
  //   <div className="card-body">
  //   <CheckoutUI id_append={trigger} margin_top={true} /> 
  //   <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>        
  //   </div>              
  //   : 
  //   <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen}/>} 
{/* <>

<div className={`modal modal-open z-[999]`}>
<div className={`overflow-visible modal-box card lg:card-side ${checkoutOpen ? "bg-[#fff7ed] w-[350px]" : "bg-base-100 w-[300px]"} p-0 max-w-[95%] md:w-[575px] lg:w-[680px] md:max-w-[50%]`}>
  {modal_id ? 
  <label onClick={closeCredits} className="btn btn-sm bg-transparent btn-outline border-none z-[11] absolute left-2 top-2 mb-2">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 mr-2 text-slate-600">
          <path fillRule="evenodd" d="M10.707 3.293a1 1 0 010 1.414L6.414 9H13a7 7 0 110 14H7a1 1 0 010-2h6a5 5 0 100-10H6.414l4.293 4.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z" clipRule="evenodd"/>
      </svg>
      Back
  </label> : null}
  {modal_open ? 
  <NextLink href={PUBLIC_ROUTES.faceContour} onClick={() => setCheckoutOpen(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</NextLink>
   : 
  <label onClick={closeAll} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label>}
  {checkoutOpen ? 
    <div className="card-body">
      <CheckoutUI id_append={trigger}/>
      <NextLink href="/checkout" onClick={() => setUiLocation("full-screen-page")} className="bg-[#fff7ed] text-center text-sm link link-hover text-blue-500 my-2">View checkout in full screen</NextLink>
    </div>
    : 
    <CreditsUI id_append={trigger} setCheckoutOpen={setCheckoutOpen} ui_location={"credits-paywall"}/>}
</div>
</div>

</> */}
